var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"healthy_ai"}},[_c('div',{attrs:{"id":"ai_box"}},[_c(_vm.aiView,{tag:"div"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }